import { combineEpics } from "redux-observable";

import getOrganizationInfoEpic$ from "./getOrganizationInfoEpic";
import getOrganizationLoginEpic$ from "./getOrganizationLoginEpic";
import getAsyncJobsEpic$ from "./getAsyncJobsEpic";
import getAsyncJobsCountEpic$ from "./getAsyncJobsCountEpic";

import updateOrganizationInfo$ from "./updateOrganizationInfoEpic";
import updateOrganizationLoginEpic$ from "./updateOrganizationLoginEpic";
import updateEmailNotification$ from "./updateEmailNotificationEpic";

import deleteAsyncJobEpic$ from "./deleteAsyncJobEpic";
import createAsyncJobEpic$ from "./createAsyncJobEpic";
import getEmailNotificationsEpic$ from "./getEmailNotificationsEpic";

import downloadAsyncJobFileEpic$ from "./downloadAsyncJobFileEpic";

export default combineEpics(
  getOrganizationInfoEpic$,
  updateOrganizationInfo$,
  getAsyncJobsEpic$,
  deleteAsyncJobEpic$,
  createAsyncJobEpic$,
  getEmailNotificationsEpic$,
  updateEmailNotification$,
  getAsyncJobsCountEpic$,
  downloadAsyncJobFileEpic$,
  getOrganizationLoginEpic$,
  updateOrganizationLoginEpic$
);



// WEBPACK FOOTER //
// ./src/features/organization/epics/index.js